import { User } from "../redux/reducers/user/user";
import pageViewEvent from "./pageViewEvents";
import { loginUserEvent, logoutUserEvent } from "./authEvents";

export const LOCATION_CHANGE = "CUSTOM/LOCATION_CHANGE";

const eventsMapper = action => {
  switch (action.type) {
    case LOCATION_CHANGE:
      return pageViewEvent;
    case User.USER_SIGN_IN:
      return loginUserEvent;
    case User.USER_SIGN_OUT:
      return logoutUserEvent;
    default:
      return null;
  }
};

export default eventsMapper;
